// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * THIS IS AN AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Any changes you make here may be lost.
 *
 * If you need to make changes, please do so in the original source file, \{project-root\}/sources/custom
 */

import { OperationOptions } from "@azure-rest/core-client";

/** Simple transcription response */
export interface AudioResultSimpleJson {
  /** Transcribed text. */
  text: string;
}

/** Transcription response. */
export interface AudioResultVerboseJson extends AudioResultSimpleJson {
  /** Audio transcription task. */
  task: AudioTranscriptionTask;
  /** Language detected in the source audio file. */
  language: string;
  /** Duration. */
  duration: number;
  /** Segments. */
  segments: AudioSegment[];
}

/** Transcription segment. */
export interface AudioSegment {
  /** Segment identifier. */
  id: number;
  /** Segment start offset. */
  start: number;
  /** Segment end offset. */
  end: number;
  /** Segment text. */
  text: string;
  /** Temperature. */
  temperature: number;
  /** Average log probability. */
  avgLogprob: number;
  /** Compression ratio. */
  compressionRatio: number;
  /** Probability of 'no speech'. */
  noSpeechProb: number;
  /** Tokens in this segment */
  tokens: number[];
  /** TODO */
  seek: number;
}

/** The options for an audio transcription request */
export interface GetAudioTranscriptionOptions extends OperationOptions {
  /** An optional text to guide the model's style or continue a previous audio segment. The prompt should match the audio language. */
  prompt?: string;
  /**
   * The sampling temperature, between 0 and 1.
   * Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.
   * If set to 0, the model will use log probability to automatically increase the temperature until certain thresholds are hit.
   */
  temperature?: number;
  /** The language of the input audio. Supplying the input language in ISO-639-1 format will improve accuracy and latency. */
  language?: string;
}

/** The options for an audio translation request */
export interface GetAudioTranslationOptions extends OperationOptions {
  /** An optional text to guide the model's style or continue a previous audio segment. The prompt should match the audio language. */
  prompt?: string;
  /**
   * The sampling temperature, between 0 and 1.
   * Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.
   * If set to 0, the model will use log probability to automatically increase the temperature until certain thresholds are hit.
   */
  temperature?: number;
}

/** The result format of an audio task */
export type AudioResultFormat =
  | "json"
  /** This format will return an JSON structure containing an enriched structure with the transcription. */
  | "verbose_json"
  /** This will make the response return the transcription as plain/text. */
  | "text"
  /** The transcription will be provided in SRT format (SubRip Text) in the form of plain/text. */
  | "srt"
  /** The transcription will be provided in VTT format (Web Video Text Tracks) in the form of plain/text. */
  | "vtt";
/** Audio transcription task type */
/** "transcribe", "translate" */
export type AudioTranscriptionTask = string;
/** The type of the result of the transcription based on the requested response format */
export type AudioResult<ResponseFormat extends AudioResultFormat> = {
  json: AudioResultSimpleJson;
  verbose_json: AudioResultVerboseJson;
  vtt: string;
  srt: string;
  text: string;
}[ResponseFormat];
